export class VarianceReopenPostCommand {
    varianceId: string;
    user: string;
    userEmail: string;
    reason: string;

    constructor(varianceId: string, user: string, userEmail: string, reason: string) {
        this.varianceId = varianceId;
        this.user = user;
        this.userEmail = userEmail;
        this.reason = reason;
    }
}
